import api from './client';
import type { Planning, ChargeArtisanResponse, ChargeArtisanAllResponse } from 'types/planning';

interface PlanningCreatePayload {
  project_id: string;
  org_id: string;
  model: string;
  start_date: string;
  sections: Planning['sections'];
  planning_template_id?: string;
}

interface PlanningUpdatePayload {
  model?: string;
  start_date?: string;
  sections?: Planning['sections'];
  planning_template_id?: string;
}

export const planningsApi = {
  list: async (params: { org_id: string; project_id?: string }): Promise<Planning[]> => {
    const { data } = await api.get('/plannings', { params });
    return data as Planning[];
  },

  get: async (planningId: string): Promise<Planning> => {
    const { data } = await api.get(`/plannings/${planningId}`);
    return data as Planning;
  },

  create: async (payload: PlanningCreatePayload): Promise<Planning> => {
    const { data } = await api.post('/plannings', payload);
    return data as Planning;
  },

  update: async (planningId: string, payload: PlanningUpdatePayload): Promise<Planning> => {
    const { data } = await api.patch(`/plannings/${planningId}`, payload);
    return data as Planning;
  },

  delete: async (planningId: string): Promise<void> => {
    await api.delete(`/plannings/${planningId}`);
  },

  getChargeArtisan: async (params: {
    org_id: string;
    section_key: string;
    force?: boolean;
  }): Promise<ChargeArtisanResponse> => {
    const { data } = await api.get('/plannings/charge-artisan', { params });
    return data as ChargeArtisanResponse;
  },

  getChargeArtisanAll: async (params: {
    org_id: string;
    force?: boolean;
  }): Promise<ChargeArtisanAllResponse> => {
    const { data } = await api.get('/plannings/charge-artisan-all', { params });
    return data as ChargeArtisanAllResponse;
  },

  getChargeArtisanByPartner: async (params: { org_id: string; partner_id: string; force?: boolean }) => {
    const { data } = await api.get(`/plannings/charge-artisan/${params.partner_id}`, {
      params: { org_id: params.org_id, force: params.force },
    });
    return data;
  },
};
